import * as React from 'react';
import * as main from "../../main.module.scss";
import * as res from "./style.module.scss";
export const Reasons = () => {
  return (
    <section className={res.res}>
      <div className="container">
        <h2 className={main.title}>Этот мастер-класс для вас, если:</h2>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_01.png" alt=""/>
            <p>Уже давно учите английский, пробовали другие курсы, но всё <strong>никак не выучите</strong></p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_02.png" alt=""/>
            <p>Уверены, что изучение языка <strong>займет годы</strong>, нужна будет постоянная практика, и вы не знаете <strong>с чего начать</strong></p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_03.png" alt=""/>
            <p>Не можете <strong>заговорить</strong> и <strong>языковой барьер</strong> кажется непреодолимым</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_04.png" alt=""/>
            <p>У вас <strong>нет времени</strong> учить язык долго, он нужен вам для работы, поездки или повышения уже скоро или вчера</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_05.png" alt=""/>
            <p>Испытываете <strong>сложности в общении</strong> с иностранцами или думаете о переезде</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_06.png" alt=""/>
            <p>Вам <strong>скучно</strong> учить язык, учебники и репетиторы отнимают всё желание</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_07.png" alt=""/>
            <p><strong>Вы никогда не учили английский язык</strong></p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/foryou_08.png" alt=""/>
            <p><strong>Вы не умеете читать транскрипции</strong></p>
          </li>
        </ul>
        <div className={main.centeredBtnBlock}>
          <a href="#widget" className={main.btn}>Мне это нужно!</a>
        </div>
      </div>
    </section>
  );
};
